/* Prevent the Brands nav item from navigating on desktop click */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('header a, header button').forEach((el) => {
    if (el.textContent.trim() === 'Brands') {
      el.addEventListener('click', (e) => {
        if (!window.matchMedia('(max-width: 749px)').matches) {
          e.preventDefault();
        }
      });
    }
  });
});
